import React, { FormEvent, useMemo } from "react";
import {
    SearchBoxProps,
    LookupItemModel,
} from "../../../models";
import { getLabelName } from "../../../utils";
import { TextBox, ButtonBox, SelectBox } from "../..";

export const SearchBoxGeneric: React.FC<SearchBoxProps> = ({
                                                               searchFields,
                                                               onChangeHandler,
                                                               onSearchHandler,
                                                               onResetHandler,
                                                               resetVersion = 0,
                                                           }) => {
    // Order fields if order is provided
    const orderedFields = useMemo(() => {
        return [...searchFields].sort(
            (a, b) => (a.order ?? 999) - (b.order ?? 999)
        );
    }, [searchFields]);

    return (
        <div className="d-flex mb-4 flex-wrap align-items-center">
            {orderedFields.map((field) => {
                const controlType = field.controlType ?? "text";
                const width = field.width ?? 280;

                return (
                    <div
                        key={field.key}
                        className="me-3 d-flex align-items-center"
                        style={{ width }}
                    >
                        {controlType === "select" ? (
                            <SelectBox
                                /* 🔑 resetVersion forces remount on Clear */
                                key={`${field.key}-${resetVersion}`}
                                labelName={getLabelName(field.label)}
                                inputName={field.key}
                                isDisabled={field.isDisabled ?? false}
                                isDataLoading={false}
                                source={field.lookupList || []}
                                selectedValues={
                                    field.value ? [field.value] : null
                                }
                                isSingleSelect={true}
                                onStatusChange={(selected: LookupItemModel | null) => {
                                    onChangeHandler(field.key, selected?.value ?? "");
                                }}
                                defaultToFirstOption={false}
                            />
                        ) : (
                            <TextBox
                                inputName={field.key}
                                inputValue={field.value}
                                labelName={getLabelName(field.label)}
                                placeHolder={getLabelName(field.placeholder || field.key)}
                                onChange={(e: FormEvent<HTMLInputElement>) =>
                                    onChangeHandler(field.key, e.currentTarget.value)
                                }
                            />
                        )}
                    </div>
                );
            })}

            {/* Actions */}
            <div className="col d-flex align-items-end justify-content-end mt-3">
                <ButtonBox
                    iconType="account-search"
                    className="btn-sm mx-2 btn-gradient-primary mb-3"
                    size="sm"
                    onClick={onSearchHandler}
                >
                    {getLabelName("search")}
                </ButtonBox>

                <ButtonBox
                    iconType="receipt"
                    variant="danger"
                    className="btn btn-sm mb-3"
                    size="sm"
                    onClick={onResetHandler}
                >
                    {getLabelName("clear")}
                </ButtonBox>
            </div>
        </div>
    );
};
